import { render, staticRenderFns } from "./MostWantedFeaturePage.vue?vue&type=template&id=33cf68d0&"
import script from "./MostWantedFeaturePage.vue?vue&type=script&lang=js&"
export * from "./MostWantedFeaturePage.vue?vue&type=script&lang=js&"
import style0 from "./MostWantedFeaturePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports